module.exports = __webpack_public_path__ + "static/room1-5-1bca004e1d26619cf354bc5f61b7c633.jpg";